import * as React from "react";
const SvgNotify = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M13.843 17.18c0 1.551-1.268 2.82-2.82 2.82a2.83 2.83 0 0 1-1.992-.827 2.83 2.83 0 0 1-.827-1.993M11.024 2a5.644 5.644 0 0 0-5.64 5.64v2.716c0 .573-.244 1.448-.536 1.936l-1.08 1.796c-.668 1.109-.207 2.34 1.014 2.754a19.67 19.67 0 0 0 12.474 0 1.882 1.882 0 0 0 1.015-2.754l-1.081-1.796c-.282-.488-.527-1.363-.527-1.936V7.64c0-3.102-2.537-5.64-5.64-5.64Z"
    />
  </svg>
);
export default SvgNotify;
